import { useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";

function AuctionERPBreadcrumb({ items }) {
  const containerRef = useRef(null);
  const itemRefs = useRef([]);
  const [visibleItems, setVisibleItems] = useState(items);
  const [hiddenItems, setHiddenItems] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const history = useHistory();

  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

  useEffect(() => {
    if (!containerRef.current || !items.length) return;

    // First render items to measure them
    setVisibleItems(items);
    setHiddenItems([]);

    if (isMobile) {
      setTimeout(() => {
        // Start with all items visible
        let currentVisibleItems = [...items];
        let currentHiddenItems = [];

        // Special cases for small arrays
        if (items.length <= 2) {
          setVisibleItems(items);
          setHiddenItems([]);
          setShowDropdown(false);
          return;
        }

        // Keep checking until items fit or we can't hide more
        currentVisibleItems = [];
        currentHiddenItems = [];

        currentVisibleItems = [items[0], items[items.length - 1]];
        currentHiddenItems = items.slice(1, items.length - 1);

        // Update final state
        setVisibleItems(currentVisibleItems);
        setHiddenItems(currentHiddenItems);
        setShowDropdown(currentHiddenItems.length > 0);
      }, 0);
    }
  }, [items, isMobile]);

  return (
    <div
      ref={containerRef}
      className="d-flex justify-content-start align-items-center w-100 flex-wrap"
    >
      {items.length > 0 && (
        <i
          className="bi bi-arrow-left text-dark text-sm mx-1 cursor-pointer fw-bold "
          onClick={() => {
            const url = items[items.length - 2]?.link;
            if (url) {
              history.push(url);
            }
          }}
        ></i>
      )}
      {visibleItems.map((item, index) => {
        // Is this the last visible item before dropdown?
        const isBeforeDropdown = showDropdown && index === 1;

        // Is this the current page? (last item)
        const isCurrentPage = index === visibleItems.length - 1;

        return (
          <div
            className="d-flex align-items-center justify-content-start"
            key={(element) => itemRefs.current.push(element)}
          >
            {/* Show dropdown before the current page */}
            {isBeforeDropdown && hiddenItems.length > 0 && (
              <>
                <div
                  className="dropdown mx-1"
                  style={{ position: "relative", zIndex: 9999 }}
                >
                  <i
                    className="bi bi-three-dots text-sm cursor-pointer"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  ></i>
                  <ul
                    className="dropdown-menu p-0 border bg-white py-2"
                    style={{ zIndex: 10000, width: "fit-content" }}
                  >
                    {hiddenItems?.map((value, hiddenIndex) => (
                      <li
                        key={hiddenIndex}
                        className="text-capitalize text-sm cursor-pointer"
                        onClick={() => {
                          if (value?.link) {
                            history.push(value?.link);
                          }
                        }}
                      >
                        <span className="dropdown-item d-flex align-items-center gap-2">
                          <span className="text-capitalize">{value?.name}</span>
                        </span>
                      </li>
                    ))}
                  </ul>
                </div>
                <i className="bi bi-chevron-right text-sm mx-1"></i>
              </>
            )}
            <span
              onClick={() => {
                if (item?.link) {
                  history.push(item?.link);
                }
              }}
              id={`breadcrumb-item-${index}`}
              className={` rounded-1 p-1 text-nowrap ${
                isCurrentPage
                  ? " text-dark fw-semibold"
                  : " cursor-pointer breadcrumb-item"
              }`}
            >
              {item?.name}
            </span>
            {/* Show chevron if not the last item */}
            {!isCurrentPage && (
              <i className="bi bi-chevron-right text-sm mx-1"></i>
            )}
          </div>
        );
      })}
    </div>
  );
}

export default AuctionERPBreadcrumb;
